// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from "react";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvText from "@directv-digital/dds.ui.dtv-text";
import CardMedia from "@mui/material/CardMedia";

export const RewardHeading = ({
  topper,
  id,
  hightlightBarColor,
  isTopperImageAvailable,
  rewardTextColor,
  lightTextColor,
  lazyLoadImages
}) => (
    <DtvBox
      sx={{
        width: "100%",
        minHeight: {
          md: "26px",
          sm: "24px",
          xs: "24px"
        },
        borderRadius: {
          md: "0px 12px 0px 0px",
          sm: "0px 12px 0px 0px",
          xs: "10px 12px 0px 0px"
        },
        background: hightlightBarColor || "#102641"
      }}
    >
      <DtvBox
        sx={{
          height: {
 md: "26px",
sm: "24px",
xs: "24px"
},
          padding: "3px 0px 0px 0px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          ...(isTopperImageAvailable && {
            height: {
              md: "64px",
              sm: "64px",
              xs: "64px"
            }
          })
        }}
      >
        <DtvText
          component={"div"}
          content={topper?.content?.content}
          id={`${id}-topper`}
          variant="smalltextmedium"
          sx={{
            color: rewardTextColor || lightTextColor
          }}
          tooltip={{
            content: topper?.content?.tooltip?.content,
            mode: topper?.content?.tooltip?.mode,
            position: topper?.content?.tooltip?.position
          }}
        />

        {topper?.content?.image?.imageUrl && (
          <CardMedia
            alt={topper?.content?.image?.altText || `topper image`}
            component={"img"}
            loading={lazyLoadImages ? "lazy" : "eager"}
            src={topper?.content?.image?.imageUrl}
            key={`image-${
              topper?.content?.image?.position || "right"
            }-${id}-topper`}
            sx={{
              height: "41px",
              width: "64px",
              marginLeft:
                topper?.content?.image?.position === "right" ? "10px" : 0,
              marginRight:
                topper?.content?.image?.position === "left" ? "10px" : 0
            }}
          />
        )}
      </DtvBox>
    </DtvBox>
);
